export const patternBiographyGrid = () => {
  $('.pattern-biography-grid .type-people').each(function () {
    let title = $(this).find('.wp-block-person-details').text();
    // $(this)
    //   .find('.wp-block-post-featured-image')
    //   .append(
    //     '<div class="person-hover"><span>' +
    //       title +
    //       '</span><span>View Bio</span></div>'
    //   );
  });

  //lightbox
  $('.pattern-biography-grid .type-people').click(function () {
    let contents = $(this).html();

    $('.site-content').append(
      '<div id="biobox" class="biography-popup" style="display:none;"><div class="popup-contents" data-scroll-sticky data-scroll-target="#biobox"><div class="bio-scroll-box"><a href="#" class="popup-closer">Close</a>' +
        contents +
        '</div></div></div>'
    );

    $('.biography-popup').fadeIn(150);

    $('body').addClass('locked');
  });

  $('body').on('click', '.popup-closer', function () {
    $('.biography-popup').remove();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '.biography-popup', function () {
    $('.biography-popup').remove();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '.popup-contents', function (e) {
    e.stopPropogation();
  });

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      $('.biography-popup').remove();
      $('body').removeClass('locked');
    }
  });
};
